var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._l(_vm.movieChunks, function(chunk, chunkIndex) {
      return _c(
        "LazyArea",
        {
          key: chunkIndex,
          class: chunk.wrapperClass,
          attrs: { "force-visible": chunk.forceVisible }
        },
        [
          _c("div", {
            style: chunk.placeholderStyle,
            attrs: { slot: "placeholder" },
            slot: "placeholder"
          }),
          _c(
            "BaseTransitionGroup",
            {
              staticClass:
                "relative grid grid-cols-fill-32 gap-3 desktop:grid-cols-fill-40",
              attrs: { animation: "fade" },
              on: { "before-leave": _vm.sendMovieToCollection }
            },
            _vm._l(chunk.movies, function(movie) {
              return _c("MoviesGridItem", {
                key: movie.id,
                staticClass: "list-complete-item",
                attrs: { movie: movie }
              })
            }),
            1
          )
        ],
        1
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }